import { Folder, Requirement } from "../../redux/interfaces/folder.types.ts";

export function findRequirement(
  folder: Folder,
  subfolderSlugMatch: (slug: string) => boolean,
  requirementSlug: string,
): Requirement | undefined {
  const subfolder = folder.subfolders?.find((sf) =>
    subfolderSlugMatch(sf.slug),
  );
  return subfolder?.requirements.find((r) => r.slug === requirementSlug);
}
